import React from "react";
import { Box, Flex, Heading, Text, Link } from 'theme-ui'
import LottieTeam from './lottie-test';
import FooterLinks from './footerLinks';
import { useColorMode } from 'theme-ui'
import { motion } from "framer-motion";
import { Linkedin, Instagram} from 'react-feather';


const SiteFooter = ({ footerVariant, location,data,props}) => {
    
    const [colorMode, setColorMode] = useColorMode()

    //get date for copyright year
    const today = new Date();
    //get pathnames from location 
    var pathname = location.pathname;
    //split it so that we can test if we are a child of /work/
    var split_pathname = pathname.split('/');
    if ( split_pathname[2] ==='category' || !split_pathname[2] || (split_pathname[1] ==='work' && !split_pathname[2]) ) {
        return (
            <Flex as="footer" className="scrollItem scrollNormal" py={5} variant={footerVariant}>
                <motion.div initial={{ opacity: 0 }} whileInView={{ opacity: 1, transition: { duration: 0.5, } }}>
                <Flex
          
                    sx={{
                        width: 'fullWidth',
                        flexDirection:['column','row'],
                        alignItems:'center',
                    }}
                >
                    <Box
                        sx={{
                            
                            paddingLeft: [2, 3, 4],
                            width:['100vw','50vw','33vw']
                        }}
                    >
                        <Heading
                            as={'h5'}
                            variant="display"
                            
                        >Let's talk</Heading>
                        <Text
                            as={'p'}
                            sx={{
                                    fontSize: [2, 3, 4]
                                }}
                        >
                            01908 319034<br />
                            <Link
                                variant="foot"
                                href="mailto:info@whpcreative.co.uk"
                            >info@whpcreative.co.uk</Link>
                        </Text>
                    </Box>
                    <Box
                        sx={{
                            width: ['100%','70%'],
                            paddingRight: [2, 3, 4] 
                        }}
                        >
                            <motion.div initial={{opacity:0, y: -100 }} whileInView={{ opacity:1,y: 0, transition: { duration: 0.3 } }}>
                                <LottieTeam />
                            </motion.div>
                    </Box>
                </Flex>
                <Flex sx={{ justifyContent: 'space-between' ,flexDirection:['column','row']}}>
                      
                        <Box sx={{ paddingTop: [1, 2, 3]  }} >
                            <Text variant="tiny" sx={{ paddingLeft: [2, 3, 4], paddingTop: [1, 2, 3] }}> WHP Creative &copy; {today.getFullYear()} </Text> / <Text variant="tiny"
                                onClick={(e) => { setColorMode(colorMode === 'default' ? 'dark' : 'default');
                                window.dispatchEvent(new Event('resize'));   }}>{colorMode === 'default' ? 'Turn out the lights' : 'Let there be light'}
                            </Text>
                        </Box>
                    <Text
                        variant="tiny"
                        sx={{
                            paddingX: [2, 3, 4],
                            paddingTop: [1, 2, 3]
                            }}>
                        
                            <Link
                                aria-label="Work"
                                variant="foot"
                                href="/work/"
                            sx={{ color: 'white' }}>Work</Link><Box
                                as="span"
                                className="slash"
                              marginLeft={['2px','5px', '10px']}
                              marginRight={['2px','5px','10px']}>/</Box> 
                            <Link
                                aria-label="What we do"
                                variant="foot"
                                href="/what-we-do/"
                            sx={{ color: 'white' }}>What we do</Link><Box
                                as="span"
                                className="slash"
                              marginLeft={['2px','5px', '10px']}
                              marginRight={['2px','5px','10px']}>/</Box> 
                            <Link
                                aria-label="Contact"
                                variant="foot"
                                href="/contact/"
                            sx={{ color: 'white' }}>Contact</Link><Box
                                as="span"
                                className="slash"
                              marginLeft={['2px','5px', '10px']}
                                marginRight={['2px', '5px', '10px']}>/</Box> 
                           
                                <Link aria-label="Instagram" target={"_blank"} variant="foot" href="https://www.instagram.com/whpcreative/" ><Instagram  style={{verticalAlign:"middle"}}  color="#fff" size={16} strokeWidth={1.25} /></Link>
                                 <Box as="span" className="slash" marginLeft={['2px','5px', '10px']} marginRight={['2px','5px','10px']}>
                                <Link aria-label="Linkedin" target={"_blank"} variant="foot" href="https://www.linkedin.com/company/whp-creative" sx={{verticalAlign:"middle"}} ><Linkedin  style={{verticalAlign:"middle"}} color="#fff" size={16}  strokeWidth={1.25} /></Link>
                                </Box> 
                           
                        
                        
                    </Text>
                    
                    </Flex>
                    <Flex sx={{ justifyContent: 'space-between', flexDirection: ['column', 'row'] }}>

                        <FooterLinks />
                        <Flex  sx={{
                                flexDirection: ['column', 'row'],
                                flexWrap:"wrap",
                                paddingY: [4, 3, 4],
                                paddingX: [2, 3, 4],
                                }}>
                            <Text as="a" href="https://www.recommendedagencies.com/whp-creative" variant="tiny">DRUM Recommended</Text>
                        </Flex>
                    </Flex>
                </motion.div>
            </Flex>
           
        )  
    } else {
        return (
           null
        )
    }
 
}

export default SiteFooter